/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuotePdfResponse
 */
export interface QuotePdfResponse {
  /**
   *
   * @type {string}
   * @memberof QuotePdfResponse
   */
  base64EncodedPdf: string;
}

/**
 * Check if a given object implements the QuotePdfResponse interface.
 */
export function instanceOfQuotePdfResponse(
  value: object,
): value is QuotePdfResponse {
  if (!("base64EncodedPdf" in value) || value["base64EncodedPdf"] === undefined)
    return false;
  return true;
}

export function QuotePdfResponseFromJSON(json: any): QuotePdfResponse {
  return QuotePdfResponseFromJSONTyped(json, false);
}

export function QuotePdfResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuotePdfResponse {
  if (json == null) {
    return json;
  }
  return {
    base64EncodedPdf: json["base64EncodedPdf"],
  };
}

export function QuotePdfResponseToJSON(json: any): QuotePdfResponse {
  return QuotePdfResponseToJSONTyped(json, false);
}

export function QuotePdfResponseToJSONTyped(
  value?: QuotePdfResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    base64EncodedPdf: value["base64EncodedPdf"],
  };
}
